import { TypeModel } from './type.model';

export class RestrictionModel {
    types: TypeModel[];
}